/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddTariffLineItemRequest } from '../models/AddTariffLineItemRequest';
import type { ApplicationQueueInfo } from '../models/ApplicationQueueInfo';
import type { CarrierTariff } from '../models/CarrierTariff';
import type { CheckVehicleReviewRequest } from '../models/CheckVehicleReviewRequest';
import type { CreateVehicleReviewRequestResult } from '../models/CreateVehicleReviewRequestResult';
import type { DrugCert } from '../models/DrugCert';
import type { GetCargoTypesResponse } from '../models/GetCargoTypesResponse';
import type { mccs_vehicle_review_request_reason } from '../models/mccs_vehicle_review_request_reason';
import type { mccs_vehicle_review_request_source } from '../models/mccs_vehicle_review_request_source';
import type { QuestionnaireData } from '../models/QuestionnaireData';
import type { RegistrationInfoDto } from '../models/RegistrationInfoDto';
import type { TarriffInfo } from '../models/TarriffInfo';
import type { TxAgent } from '../models/TxAgent';
import type { UpdateTariffRequest } from '../models/UpdateTariffRequest';
import type { VehicleBulkImportStatusResponse } from '../models/VehicleBulkImportStatusResponse';
import type { VehicleReviewCheckResult } from '../models/VehicleReviewCheckResult';
import type { VehicleReviewRequestSummary } from '../models/VehicleReviewRequestSummary';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MotorCarrierApplicationService {
  /**
   * @param applicationId
   * @returns RegistrationInfoDto OK
   * @throws ApiError
   */
  public static getApiMotorCarrierApplicationCarrierUcrRegistrationInfo(
    applicationId?: string,
  ): CancelablePromise<RegistrationInfoDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/MotorCarrierApplication/carrier-ucr-registration-info',
      query: {
        'applicationId': applicationId,
      },
    });
  }
  /**
   * @param applicationId
   * @param isNo
   * @returns any OK
   * @throws ApiError
   */
  public static postApiMotorCarrierApplicationSaveUcrCompliance(
    applicationId?: string,
    isNo?: boolean,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/MotorCarrierApplication/save-ucr-compliance',
      query: {
        'applicationId': applicationId,
        'isNo': isNo,
      },
      errors: {
        404: `Not Found`,
        409: `Conflict`,
      },
    });
  }
  /**
   * ...
   * @param applicationId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static saveTexasAgent(
    applicationId: string,
    requestBody?: TxAgent,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/MotorCarrierApplication/{applicationId}/texas-agent',
      path: {
        'applicationId': applicationId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * ...
   * @param applicationId
   * @returns TxAgent OK
   * @throws ApiError
   */
  public static getTexasAgent(
    applicationId: string,
  ): CancelablePromise<TxAgent> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/MotorCarrierApplication/{applicationId}/texas-agent',
      path: {
        'applicationId': applicationId,
      },
    });
  }
  /**
   * Get the cargo types associated with a motor carrier. With an application, its own Hazmat override applies.
   * @param usdot
   * @param applicationId
   * @returns GetCargoTypesResponse OK
   * @throws ApiError
   */
  public static getCargoTypes(
    usdot?: number,
    applicationId?: string,
  ): CancelablePromise<GetCargoTypesResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/MotorCarrierApplication/cargo-types',
      query: {
        'usdot': usdot,
        'applicationId': applicationId,
      },
      errors: {
        401: `Unauthorized`,
        404: `Not Found`,
      },
    });
  }
  /**
   * @param applicationId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static postApiMotorCarrierApplicationSaveCargoType(
    applicationId?: string,
    requestBody?: TarriffInfo,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/MotorCarrierApplication/save-cargo-type',
      query: {
        'applicationId': applicationId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Get the standard tariff line items for the carrier tied to this application
   * @param applicationId
   * @returns CarrierTariff OK
   * @throws ApiError
   */
  public static getTariffs(
    applicationId: string,
  ): CancelablePromise<Array<CarrierTariff>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/MotorCarrierApplication/{applicationId}/tariffs',
      path: {
        'applicationId': applicationId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Add a standard tariff line item to the carrier tied to this application
   * @param applicationId
   * @param requestBody
   * @returns CarrierTariff OK
   * @throws ApiError
   */
  public static addTariff(
    applicationId: string,
    requestBody?: AddTariffLineItemRequest,
  ): CancelablePromise<CarrierTariff> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/MotorCarrierApplication/{applicationId}/tariffs',
      path: {
        'applicationId': applicationId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        404: `Not Found`,
      },
    });
  }
  /**
   * Update the description and amount of a standard tariff line item for the carrier tied to this application
   * @param applicationId
   * @param tariffId
   * @param requestBody
   * @returns CarrierTariff OK
   * @throws ApiError
   */
  public static updateTariff(
    applicationId: string,
    tariffId: string,
    requestBody?: UpdateTariffRequest,
  ): CancelablePromise<CarrierTariff> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/MotorCarrierApplication/{applicationId}/tariffs/{tariffId}',
      path: {
        'applicationId': applicationId,
        'tariffId': tariffId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        404: `Not Found`,
      },
    });
  }
  /**
   * Delete a standard tariff line item from the carrier tied to this application
   * @param applicationId
   * @param tariffId
   * @returns any OK
   * @throws ApiError
   */
  public static deleteTariff(
    applicationId: string,
    tariffId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/MotorCarrierApplication/{applicationId}/tariffs/{tariffId}',
      path: {
        'applicationId': applicationId,
        'tariffId': tariffId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * @param applicationId
   * @returns DrugCert OK
   * @throws ApiError
   */
  public static postApiMotorCarrierApplicationGetDrugTestInfo(
    applicationId?: string,
  ): CancelablePromise<DrugCert> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/MotorCarrierApplication/get-drug-test-info',
      query: {
        'applicationId': applicationId,
      },
    });
  }
  /**
   * @param applicationId
   * @param requestBody
   * @returns ApplicationQueueInfo OK
   * @throws ApiError
   */
  public static postApiMotorCarrierApplicationSaveDrugTestCert(
    applicationId?: string,
    requestBody?: DrugCert,
  ): CancelablePromise<Array<ApplicationQueueInfo>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/MotorCarrierApplication/save-drug-test-cert',
      query: {
        'applicationId': applicationId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param applicationId
   * @returns QuestionnaireData OK
   * @throws ApiError
   */
  public static getApiMotorCarrierApplicationGetQuestionnaireInfo(
    applicationId?: string,
  ): CancelablePromise<QuestionnaireData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/MotorCarrierApplication/get-questionnaire-info',
      query: {
        'applicationId': applicationId,
      },
    });
  }
  /**
   * @param applicationId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static postApiMotorCarrierApplicationSaveQuestionnaireInfo(
    applicationId?: string,
    requestBody?: QuestionnaireData,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/MotorCarrierApplication/save-questionnaire-info',
      query: {
        'applicationId': applicationId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Upload a CSV to bulk create/update vehicles (by VIN) for a motor carrier application. Processed asynchronously in the background; poll GetVehicleBulkImportStatus for progress.
   * @param applicationId
   * @param formData
   * @returns VehicleBulkImportStatusResponse Accepted
   * @throws ApiError
   */
  public static bulkUploadVehicles(
    applicationId: string,
    formData?: {
      File: Blob;
    },
  ): CancelablePromise<VehicleBulkImportStatusResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/MotorCarrierApplication/{applicationId}/vehicles',
      path: {
        'applicationId': applicationId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Get the status of the most recent bulk vehicle CSV import for a motor carrier application.
   * @param applicationId
   * @returns VehicleBulkImportStatusResponse OK
   * @throws ApiError
   */
  public static getVehicleBulkImportStatus(
    applicationId: string,
  ): CancelablePromise<VehicleBulkImportStatusResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/MotorCarrierApplication/{applicationId}/vehicles/status',
      path: {
        'applicationId': applicationId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Report which vehicles need TX review, and for which reasons, before adding them to an application.
   * @param applicationId
   * @param requestBody
   * @returns VehicleReviewCheckResult OK
   * @throws ApiError
   */
  public static checkApplicationVehicleReview(
    applicationId: string,
    requestBody?: CheckVehicleReviewRequest,
  ): CancelablePromise<VehicleReviewCheckResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/MotorCarrierApplication/{applicationId}/vehicles/review-check',
      path: {
        'applicationId': applicationId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * List the application's vehicle review requests that are still open, for any reason. The application cannot be approved while any are.
   * @param applicationId
   * @returns VehicleReviewRequestSummary OK
   * @throws ApiError
   */
  public static listOpenApplicationVehicleReviewRequests(
    applicationId: string,
  ): CancelablePromise<Array<VehicleReviewRequestSummary>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/MotorCarrierApplication/{applicationId}/vehicle-review-requests/open',
      path: {
        'applicationId': applicationId,
      },
    });
  }
  /**
   * Submit a vehicle review request for one vehicle and one reason, with its supporting documents, instead of adding the vehicle to the application.
   * @param applicationId
   * @param formData
   * @returns CreateVehicleReviewRequestResult OK
   * @throws ApiError
   */
  public static createApplicationVehicleReviewRequest(
    applicationId: string,
    formData?: {
      Reason?: mccs_vehicle_review_request_reason;
      Source?: mccs_vehicle_review_request_source;
      Vin?: string;
      MakeDescription?: string;
      Model?: string;
      ModelYear?: number;
      UnitNumber?: string;
      Leased?: boolean;
      LeasingCompany?: string;
      LeasingUsdot?: number;
      PassengerCapacity?: number;
      AddToCurrentRegistration?: boolean;
      ReplacesVehicleId?: number;
      Files?: Array<Blob>;
    },
  ): CancelablePromise<CreateVehicleReviewRequestResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/MotorCarrierApplication/{applicationId}/vehicle-review-requests',
      path: {
        'applicationId': applicationId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        409: `Conflict`,
      },
    });
  }
}
